import { Component, OnInit, Input, Output, ChangeDetectionStrategy, EventEmitter, ViewEncapsulation } from '@angular/core';
import { WrapUpCode } from 'common/store/genesys-cloud/conversations/common/models/wrap-up-code.model';
import { CommunicationType } from 'common/store/genesys-cloud/conversations/common/models/communication-type.enum';

@Component({
  selector: 'app-genesys-wrapup-panel',
  templateUrl: './genesys-wrapup-panel.component.html',
  styleUrls: ['./genesys-wrapup-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysWrapupPanelComponent implements OnInit {
  readonly CommunicationType = CommunicationType;

  @Input()
  conversationId: string;

  @Input()
  selectedWrapUp: WrapUpCode;

  @Input()
  isWrapUpRequired: boolean;

  @Input()
  isConversationClosed: boolean;

  @Input()
  wrapUpCodes: WrapUpCode[];

  @Input()
  disableButtons: boolean;

  @Input()
  communicationType: CommunicationType;

  @Output()
  togglePanel = new EventEmitter<void>();

  @Output()
  selected = new EventEmitter<WrapUpCode>();

  @Output()
  submitted = new EventEmitter<WrapUpCode>();

  @Output()
  skipped = new EventEmitter<void>();

  selectedItem?: WrapUpCode;

  isDropdownOpen = false;

  setDropdown(newDropdownState: boolean) {
    this.isDropdownOpen = newDropdownState;
  }

  ngOnInit(): void {
    this.selectedItem = this.selectedWrapUp;
  }

  onSelect() {
    this.togglePanel.emit();
    this.selected.emit(this.selectedItem);
  }

  onSubmit() {
    if (!this.isWrapUpRequired && !this.selectedItem?.id) {
      this.skipped.emit();
    } else {
      this.submitted.emit(this.selectedItem);
    }
  }

  onCancel() {
    this.togglePanel.emit();
  }

  isSelectionValid() {
    return !this.isWrapUpRequired || this.selectedItem?.id;
  }

  changeWrapup(selectedWrapUp: WrapUpCode | null) {
    this.selectedItem = selectedWrapUp;
  }
}
